import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import Footer from '../../Footer';
import TopBar from '../../TopBar';

export interface LayoutProps {
    children?: React.ReactNode;
    topBarMaxWidth?: number;
    contentFlexDirection?: FlexDirection['direction'];
};

export interface FlexDirection {
    direction: 'column' | 'row';
};

const Layout = (props: LayoutProps) => {
    let flexDirection = props.contentFlexDirection;

    if (flexDirection === undefined) {
        flexDirection = 'row';
    };
    
    return (
        <Flex flexDirection='column' flex='1' height='100%'>
            <TopBar maxWidth={ props.topBarMaxWidth } />
            <Box display='flex' flex='1' flexDirection={ flexDirection } >
                { props.children }
            </Box>
            <Footer />
        </Flex>
    );
};

export default Layout;